var Flickity = require('flickity-fullscreen');

import 'flickity/js/drag';
import 'flickity/js/prev-next-button';
import 'flickity/js/page-dots';
import 'flickity/js/player';

import { CarouselWide } from './carousel-wide';
import { CarouselGrouped } from './carousel-grouped';
import { CarouselCropped } from './carousel-cropped';
import { CarouselSingle } from './carousel-single';
import { CarouselCareer } from './carousel-career';

new CarouselWide(Flickity);
new CarouselGrouped(Flickity);
new CarouselCropped(Flickity);
new CarouselSingle(Flickity);
new CarouselCareer(Flickity);


// iOS 13 fix
(function() {
  let touchingCarousel = false,
    touchStartCoords;

  document.body.addEventListener('touchstart', (e) => {
    if (e.target.closest('.flickity-slider')) {
      touchingCarousel = true;
    } else {
      touchingCarousel = false;
      return;
    }

    touchStartCoords = {
      x: e.touches[0].pageX,
      y: e.touches[0].pageY,
    };
  });

  document.body.addEventListener(
    'touchmove',
    (e) => {
      if (!(touchingCarousel && e.cancelable)) {
        return;
      }

      let moveVector = {
        x: e.touches[0].pageX - touchStartCoords.x,
        y: e.touches[0].pageY - touchStartCoords.y,
      };

      if (Math.abs(moveVector.x) > 7) e.preventDefault();
    },
    { passive: false },
  );
})();


// WEBPACK FOOTER //
// ./src/js/carousels.js